import request from "helpers/api_helper";
import { toast } from "react-toastify";

// Get all booking questions
export const getBookingQuestions = async (queryString?: string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `booking_questions${queryString ? `?${queryString}` : ''}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch booking questions");
    return error;
  }
};

// Get single booking question
export const getBookingQuestion = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `booking_questions/${id}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch booking question");
    return error;
  }
};

// Create new booking question
export const createBookingQuestion = async (data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "booking_questions",
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Booking question created successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to create booking question");
    return error;
  }
};

// Update booking question
export const updateBookingQuestion = async (id: number, data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `booking_questions/${id}`,
      method: "PUT", 
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Booking question updated successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to update booking question");
    return error;
  }
};

// Delete booking question
export const deleteBookingQuestion = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `booking_questions/${id}`,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Booking question deleted successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to delete booking question");
    return error;
  }
};

// Get question types
export const getQuestionTypes = async () => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "question_types",
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch question types");
    return error;
  }
};